module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section section-white content-padded",
    attrs: {
      "onload": "init()"
    }
  }, [_c('el-card', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loader),
      expression: "loader"
    }],
    attrs: {
      "header": "直播预告",
      "shadow": "never"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "110px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "主播名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "主播名称",
      "disabled": ""
    },
    model: {
      value: (_vm.form.nickname),
      callback: function($$v) {
        _vm.$set(_vm.form, "nickname", $$v)
      },
      expression: "form.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "分类"
    }
  }, [_c('el-select', {
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择直播分类"
    },
    model: {
      value: (_vm.form.cate_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "cate_id", $$v)
      },
      expression: "form.cate_id"
    }
  }, _vm._l((_vm.category), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.cate_name,
        "size": "mini",
        "value": item.cate_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "排序"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "0"
    },
    model: {
      value: (_vm.form.sort),
      callback: function($$v) {
        _vm.$set(_vm.form, "sort", $$v)
      },
      expression: "form.sort"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主讲人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "张三"
    },
    model: {
      value: (_vm.form.speaker),
      callback: function($$v) {
        _vm.$set(_vm.form, "speaker", $$v)
      },
      expression: "form.speaker"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "主讲人简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "XX专家"
    },
    model: {
      value: (_vm.form.speaker_desc),
      callback: function($$v) {
        _vm.$set(_vm.form, "speaker_desc", $$v)
      },
      expression: "form.speaker_desc"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播标题"
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播简介"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "placeholder": "直播简介"
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频详情"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    staticStyle: {
      "width": "55%"
    },
    attrs: {
      "content": _vm.form.content,
      "height": 360
    },
    on: {
      "change": _vm.updateContent
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tpl_item img",
    on: {
      "click": _vm.addImgPreview
    }
  }, [_c('i', {
    staticClass: "iconfont icon-image"
  }), _vm._v("图片\n                ")]), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.thumbDialog,
      "sc-status": _vm.isGetThumb,
      "isMost": true
    },
    on: {
      "chooseImg": _vm.pickThumb,
      "closeImgDialog": _vm.closeThumbDialog
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播开始时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "value-format": "yyyy-MM-dd HH:mm",
      "default-time": "00:00:00",
      "picker-options": _vm.pickerOptions
    },
    model: {
      value: (_vm.form.start_at),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_at", $$v)
      },
      expression: "form.start_at"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "直播间封面图片"
    }
  }, [_c('div', {
    staticClass: "upload-box",
    on: {
      "click": function($event) {
        return _vm.handleImgPicker('cover_image')
      }
    }
  }, [(_vm.form.cover_image) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.form.cover_image
    }
  }) : _c('i', {
    staticClass: "iconfont icon-camera avatar-uploader-icon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "frm-tips"
  }, [_vm._v("只能上传jpg/png文件，且不超过2M ")])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "视频类型",
      "prop": "source_video_type"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "视频类型",
      "disabled": ""
    },
    on: {
      "change": _vm.handleVideoTypeChange
    },
    model: {
      value: (_vm.form.source_video_type_text),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type_text", $$v)
      },
      expression: "form.source_video_type_text"
    }
  }, _vm._l((_vm.sourceVideoTypeOption), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_c('el-col', [_c('el-input', {
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.source_video_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "source_video_type", $$v)
      },
      expression: "form.source_video_type"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-card', {
    attrs: {
      "header": "店铺商品选品",
      "shadow": "naver"
    }
  }, [_c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "size": "large"
    },
    on: {
      "click": _vm.cancelSubmit
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.submitItemsActionConfirm
    }
  }, [_vm._v(_vm._s(_vm.submitLoading ? '提交中' : '保存'))])], 1), _vm._v(" "), _c('imgPicker', {
    attrs: {
      "dialog-visible": _vm.imgDialog,
      "sc-status": _vm.isGetImage
    },
    on: {
      "chooseImg": _vm.pickImg,
      "closeImgDialog": _vm.closeImgDialog
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-19f0a881", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19f0a881"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/live/anchor/prenotice.vue
// module id = 2508
// module chunks = 0